import type { SVGProps } from "react";

export function SendDisclosuresIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21 0.5H5.5C3.84315 0.5 2.5 1.84315 2.5 3.5V19.84C2.50004 20.8997 2.07961 21.916 1.331 22.666L0.5 23.5"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.5 4.5V3C18.5 1.61929 19.6193 0.5 21 0.5C22.38 0.5 23.5 1.619 23.5 3.5"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.5 17.5V19.84C18.5 20.8997 18.0796 21.916 17.331 22.666L16.5 23.5"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.045 18.257C8.01808 17.2762 9.59598 17.2509 10.6 18.2C11.548 19.2051 11.521 20.783 10.539 21.755C9.576 22.717 5.3 23.5 5.3 23.5C5.3 23.5 6.08 19.222 7.045 18.257Z"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8.126 20.671L5.297 23.499" stroke="#A5AAAF" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.724 18.9C12.3335 19.2904 11.7005 19.2904 11.31 18.9L9.89999 17.486C9.50961 17.0955 9.50961 16.4625 9.89999 16.072L14.847 11.125L17.676 13.953L12.724 18.9Z"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.086 6.882C18.305 6.10124 17.039 6.10124 16.258 6.882L10.6 12.538"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.086 6.882C19.8672 6.10107 21.1336 6.10129 21.9145 6.8825C22.6954 7.66371 22.6952 8.93007 21.914 9.711L17.672 13.953L14.843 11.125L19.086 6.882Z"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
